import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { NavController, ModalController } from "ionic-angular";
import { has, isString, get, toArray, isObject } from "lodash";
import { Subscription } from "rxjs";
import { PurchasesData } from "../../providers/purchases";
import { Utilities } from "../../providers/utilities";
import * as sharedSelectors from "../../shared/reducers/shared.reducer";
import { tap, map, take } from "rxjs/operators";

@Component({
  selector: "purchases-list",
  templateUrl: "purchases-list.html",
})
export class PurchasesListComponent implements OnInit, OnDestroy {

  @Input() public isPage: boolean = false;
  @Output() public emitRecords: EventEmitter<any> = new EventEmitter<any>();

  public purchases: any[];
  public purchasesTmp: any[];
  public openDetail: number;
  public clientId: string;
  public loading = false;
  public limitTo: number = 10;
  private clientSubscribe: Subscription;

  constructor(
    public navCtrl: NavController,
    private store: Store<{}>,
    private purchaseData: PurchasesData,
    private utilities: Utilities,
    private modalCtrl: ModalController
  ) { }

  public ngOnInit() {
    this.loading = true
    this.clientSubscribe = this.store.select(sharedSelectors.getClientId).subscribe(async (clientId) => {
      if (clientId) {
        this.clientId = clientId;
        this.purchasesTmp = await this.purchaseData.getAllByClient(clientId)
          .pipe(
            map(res => get(res, 'data', [])),
            map((list) => list.map((item) => {
              if (Object.keys(item.transaction).length === 0) {
                const distance = this.utilities.timeDifference(item.summary.created_at);
                // this.utilities.consoleDecorator("Distancia del item", {
                //   distance, status: this.calculateDistance(distance) ? "ABANDONED SHOPPING CART" : "PROCESS PAYMENT",
                // });
                return {
                  ...item, transaction: {
                    ...item.summary,
                    amount: item.summary.total,
                    emulated: true,
                    id: "NA",
                    creationDate: item.summary.createdAt,
                    status: this.calculateDistance(distance) ? "ABANDONED SHOPPING CART" : "PROCESS PAYMENT",
                  },
                };
              }
              return item;
            })),
            map((list) => list
              // .filter(item => get(item, 'transaction', false))
              // .filter(item => get(item.transaction, 'amount', false))
              .sort((a, b) => {
                a = new Date(a.transaction.creationDate);
                b = new Date(b.transaction.creationDate);
                return a > b ? -1 : a < b ? 1 : 0;
              })),
            tap(() => this.loading = false),
            take(1),
          ).toPromise()
        // .map((list) => list.reduce((total, next) => {
        //   return { ...total, ...next };
        // }, {}))
        // .map((list) => Object.keys(list).map((i) => list[i]))
        // .map((list) => list.filter((value) => has(value, "summary")))
        // .map((list) => list.filter((value) => has(value, "userId")))

        // .map((list) => list.filter((value) => has(value, "transaction")))
        // .do((list) => this.emitRecords.emit(list));

        this.purchases = this.purchasesTmp;
      }
    });
  }

  public isValid(item) {
    return item.transaction.status === "success" ||
      item.transaction.status === "CAPTURED" ||
      item.transaction.status === "APPROVED" ||
      item.transaction.status === "PROCESS PAYMENT";
  }

  public search(ev) {
    if (ev.target.value.trim() === '') {
      this.purchases = this.purchasesTmp
      return
    }

    this.loading = true

    this.purchases = this.purchasesTmp.filter((item) => {
      const search = ev.target.value.toLowerCase()
      if (get(item, '_id', '').toLowerCase().indexOf(search) > -1) {
        return true
      }

      const transaction = get(item, 'transaction', null)
      if (transaction) {
        if (String(get(transaction, 'id', ' ')).toLowerCase().indexOf(search) > -1) {
          return true
        }
        if (String(get(transaction, 'payment_date', ' ')).toLowerCase().indexOf(search) > -1) {
          return true
        }
        if (String(get(transaction, 'referenceCode', ' ')).toLowerCase().indexOf(search) > -1) {
          return true
        }
        if (String(get(transaction, 'merchantId', ' ')).toLowerCase().indexOf(search) > -1) {
          return true
        }
        if (String(get(transaction, 'state', ' ')).toLowerCase().indexOf(search) > -1) {
          return true
        }
      }
      return false
    })

    this.loading = false
  }

  public viewFormInfo(itemId: string, formData: any[], formFields: any[], type: string, shopId: string = null) {
    this.utilities.Modal.create("PurchasesFormPage", {
      formData,
      formFields,
      itemId,
      shopId,
      type,
    }).present();
  }

  public delivered(userId, itemId, payId, type) {
    return this.purchaseData.updateDeliveredItem(userId, payId, itemId, this.clientId, type)
      .then(() => this.utilities.setToast("The delivery status of the item has been changed."));
  }

  public handlerTypeProductToSendNotification(payment, email, type) {
    if (type === "ticket") {
      this.selectNotificationTypeTicket(payment, email);
    } else {
      this.goSendPaymentGeneral(payment, email);
    }
  }

  public selectNotificationTypeTicket(payment, email) {
    this.utilities.Alert.create({
      buttons: [{
        role: "cancel",
        text: "Cancel",
      }, {
        handler: (data) => {
          if (data === "sendPayment") {
            this.goSendPaymentGeneral(payment, email);
          } else {
            this.goSendQREmailTicket(payment);
          }
        },
        text: "Ok",
      }],
      inputs: [{
        label: "Send payment receipt",
        name: "sendPayment",
        type: "radio",
        value: "sendPayment",
      },
      {
        label: "Send tickets QR",
        name: "sendQR",
        type: "radio",
        value: "sendQR",
      },
      ],
      message: "Select option for send email notification",
      title: "Select Option",
    }).present();
  }

  public goSendPaymentGeneral(payment, email) {
    this.utilities.Alert.create({
      buttons: [{
        role: "cancel",
        text: "Cancel",
      }, {
        handler: (data) => {
          if (data.to && data.to !== "") {
            const load = this.utilities.setLoading();
            this.purchaseData.sendPaymentNotification(
              this.clientId,
              payment.userId,
              payment.id,
              [data.to],
            ).subscribe((result) => {
              load.dismiss()
                .then(() => this.utilities.setToast("The notification has been sent correctly!"))
                .then(() => this.utilities.consoleDecorator("Result email send", [result, payment]));
            });

          } else {
            return false;
          }
        },
        text: "Send",
      }],
      inputs: [{
        name: "to",
        type: "email",
        value: email,
      }],
      message: "Enter the email address for send notification of the payment",
      title: "Send notification",
    }).present();
  }

  public goSendQREmailTicket(payment) {
    this.utilities.Alert.create({
      buttons: [{
        role: "cancel",
        text: "Cancel",
      }, {
        handler: () => {
          const load = this.utilities.setLoading();
          this.purchaseData.sendPaymentNotificationQR(
            this.clientId,
            payment.userId,
            payment.id,
          ).subscribe((result) => {
            load.dismiss()
              .then(() => this.utilities.setToast("The QR code has been sent correctly!"))
              .then(() => this.utilities.consoleDecorator("Result email send", [result, payment]));
          });
        },
        text: "Send",
      }],
      message: "Are you sure to send an email with the QR of the ticket to the emails registered in the purchase?",
      title: "Send QR Email",
    }).present();
  }


  public loadMore(infiniteScroll, list: any[]) {
    if (this.limitTo < list.length) {
      this.limitTo += 10;
      setTimeout(() => {
        infiniteScroll.complete();
      }, 300);
    } else {
      infiniteScroll.enable(false);
    }
  }

  public viewUser(item: any = null) {
    if (item) {
      const object = {
        Company: { value: item.company },
        Email: { value: item.email },
        ID: { value: item.id, actions: { copy: true } },
        Name: { value: item.displayName },
        Phone: { value: item.phone },
        Position: { value: item.position },
      };
      this.utilities.Modal.create("ModalViewPage", { object, title: "User detail" }).present();
    }
  }

  public isOpen(key) {
    return this.openDetail === key;
  }

  public calculateName(transactionData) {
    return toArray(transactionData.summary.items)
      .map((item) => `<b>${item.type.toUpperCase()}</b> - ${this.translate(item.data.name)}`).join('</br>')
  }

  public open(key) {
    if (this.openDetail === key) {
      this.openDetail = null;
    } else {
      this.openDetail = key;
    }
  }

  public isString(data: any) {
    return isString(data);
  }

  public is(item, param) {
    return has(item, param);
  }

  public ngOnDestroy() {
    if (this.clientSubscribe) { this.clientSubscribe.unsubscribe(); }
  }

  public getTransactionResponse(purchase, param) {
    if (get(purchase, 'transaction', false)) {
      if (get(purchase.transaction, 'transactions', false)) {
        if (purchase.transaction.transactions[0]) {
          if (get(purchase.transaction.transactions[0], 'transactionResponse', false)) {
            if (get(purchase.transaction.transactions[0].transactionResponse, param, false)) {
              return get(purchase.transaction.transactions[0].transactionResponse, param, false);
            }
          }
        }
      }
    }
    return ''
  }

  private calculateDistance(distance) {
    // tslint:disable-next-line:use-isnan
    if (distance.day === NaN || distance.hour === NaN) {
      return true;
    }

    if (distance.day === 0) {
      return false;
    }

    if (distance.day === 1 && distance.hour <= 23) {
      return false;
    }

    return true;
  }

  // private calculateAmount(transactionData: any, type: string) {
  //   if (!this.validaReserveContent(transactionData, type)) { return false; }
  //   let total = 0;
  //   Object.keys(transactionData.summary[type]).map((key) => {
  //     total += transactionData.summary[type][key].sale_amount;
  //   });
  //   return total;
  // }

  private translate(value) {
    if (!value) { return null; }

    if (isObject(value)) {
      return !(value.en === "") ? value.en : value.es;
    } else {
      return value;
    }
  }

  public copy(item) {
    this.utilities.copyToClipboard(item);
  }

  public stats() {
    const modal = this.modalCtrl.create(
      "ModalStatsPage",
      {
        purchases: this.purchasesTmp,
      },
      { enableBackdropDismiss: false },
    );
    modal.present();
  }

  public suma(purchases: any[]) {
    return purchases.reduce((total, next) => {
      if (next.state === 'APPROVED') {
        total += next.summary.totalBase
      }
      return total
    }, 0)
  }

  private validaReserveContent(transactionData, param: string) {
    if (has(transactionData, "summary")) {
      if (has(transactionData.summary, param)) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/purchases-list/purchases-list.ts